// src/components/CostModeBanner.js
//
// PR-1 (Maliyet Kalkanı) — emergency modunda uygulamanın üstünde görünen
// nazik bilgi çubuğu. normal/limited modlarda hiçbir şey render etmez
// (sıfır maliyet, sıfır görsel değişiklik).

import useCostMode, { getCostModeConfig, COST_MODE_BANNER_TEXT } from '../hooks/useCostMode';
import { IkonKoprusu } from "../icon-system/runtime/IkonKoprusu";

export default function CostModeBanner() {
  const mode = useCostMode();
  const cfg = getCostModeConfig(mode);
  if (!cfg.showBanner) return null;

  return (
    <div
      role="status"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        background: '#fff8e1',
        color: '#7a5d00',
        borderBottom: '1px solid #f0e0a0',
        padding: '8px 12px',
        fontSize: 13,
        textAlign: 'center',
      }}
    >
      <IkonKoprusu aile="system.warning" eski="⚠️" /> {COST_MODE_BANNER_TEXT}
    </div>
  );
}
